import moment from 'moment'

export default {
  data() {
    return {
      rules: {
        required: value => !!value || 'Обязательное поле.',
        requiredNotZero: value => !!+value || 'Обязательное поле.',
        requiredObjectValue: value => !_.isEmpty(value) || 'Обязательное поле.',
        requiredArray: value => (value && value.length > 0) || 'Обязательное поле.',
        requiredCount: value => {
          if (parseInt(value) === 0) return 'Кол-во использований не может быть 0.'
          return true
        },
        requiredMaxValue: value => {
          return (value <= 5 && value >= 0) || 'Значение не может быть больше 5 и меньше 0'
        },
        requiredMaxBonusValue: value => {
          return (value <= 100000 && value >= 1) || 'Значение не может быть больше 100 000 и меньше 1'
        },
        requiredSelect: value => {
          return value === 0 || !!value || 'Обязательное поле.'
        },
        textfieldTrim: value => {
          if (value) {
            const pattern = /\s/
            return !pattern.test(value) || 'Пробел - недопустимый символ'
          }
          return true
        },
        hiddenPhone: value => {
          if (value) {
            const pattern = /\*/
            return !pattern.test(value) || '* - недопустимый символ'
          }
          return true
        },
        counter: value => value.length <= 20 || 'Максимальное число символов - 20',
        email: value => {
          if (value && value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Некорректный e-mail.'
          }
          return true
        },
        time: value => {
          const pattern = /^[0-2][0-3]\:[0-5][0-9]$/
          return pattern.test(value) || 'Некорректное время.'
        },
        percent: value => {
          return (value > 0 && value <= 100) || 'Диапазон 1-100%.'
        },
        date: value => {
          const pattern = /(\d{2}).(\d{2}).(\d{4})/
          return pattern.test(value) || 'Некорректная дата.'
        },
        price: value => {
          const pattern = /^[0-9][0-9]*([.][0-9]{1,2}|)$/
          return pattern.test(value) || 'Некорректная цена.'
        },
        confirmed: value => {
          const confirmedField = this.$refs.password.value
          return value === confirmedField || 'Пароли не совпадают'
        },
        passwordLength: value => {
          const PASSWORD_LENGTH = 6
          if (!value) return 'Поле не заполнено'
          return value.length >= PASSWORD_LENGTH || `Минимальное количество символов - ${PASSWORD_LENGTH}`
        },
        phoneLength: value => {
          const phone_min_length = 9
          if (!value) return 'Поле не заполнено'
          return value.length >= phone_min_length || `Минимальное количество символов - ${phone_min_length}`
        },
        qty: value => {
          let parsedValue = parseInt(value, 10)
          const isValid = Number.isInteger(parsedValue) && `${parsedValue}` === `${value}` && parsedValue >= 1
          return isValid || 'Недопустимое значение. Требуется 1 и выше'
        },
        notСyrillic: value => {
          const reg = /[а-яА-ЯёЁ]/g
          return value.search(reg) == -1 || 'Недопустимы кириллические символы'
        },
      },
    }
  },
}
